import { Waypoint } from 'react-waypoint'
import React, { useCallback, useEffect, useRef } from 'react'
import './styles.scss'
import { useSpring, animated as a } from 'react-spring'

export function Cover(props: {
  onLeave: (event: Waypoint.CallbackArgs) => void
}) {
  const coverSegment = useRef<HTMLDivElement>(null)
  const [{ scrollTop }, set] = useSpring(() => ({
    scrollTop: 0,
    immediate: true
  }))
  const textPosition = scrollTop.interpolate(val => `translateY(${val * 30}vh)`)
  const schwarzPosition = scrollTop.interpolate(
    val => `scale(${val * 0.6 + 0.6}) translate(${val * 10}%, 0)`
  )

  const weissPosition = scrollTop.interpolate(
    val => `scale(${val * 0.6 + 0.6}) translate(${val * 10}%, 0)`
  )

  /*
    const kasperliPosition = browserCheck.isMobile
    ? scrollTop.interpolate(
        val => `scale(${val * 0.6 + 0.6}) translate(${val * 10 - 20}%, 0)`
      )
    : scrollTop.interpolate(
        val => `scale(${val * 0.6 + 0.6}) translate(${val * 10 - 15}%, 0)`
      )
  const genderPosition = browserCheck.isMobile
    ? scrollTop.interpolate(
        val => `scale(${val * 0.6 + 0.6}) translate(${val * 10 + 50}%, 0)`
      )
    : scrollTop.interpolate(
        val => `scale(${val * 0.6 + 0.6}) translate(40%, 0)`
      )
    */
  const onScroll = useCallback(e => {
    if (e.target.scrollingElement && coverSegment.current) {
      set({
        scrollTop:
          e.target.scrollingElement.scrollTop /
          coverSegment.current.clientHeight
      })
    }
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div
      className='ui vertical segment'
      id='cover'
      ref={coverSegment}
      style={{ backgroundImage: `url(${require('./symbols.png')})` }}
    >
      <a.div style={{ transform: textPosition }} className='ui text container'>
        <div className='ui header'>
          <h1>Wie politisch korrekt sind Sie?</h1>
          <h2>
            Bewerten Sie 20 Statements und sehen Sie, wie politisch korrekt Sie
            sind im Vergleich zu anderen Leserinnen und Lesern.
          </h2>
        </div>
        <Waypoint scrollableAncestor={window} onLeave={props.onLeave} />

        <div className='ta author'>Philippe Zweifel und Interaktiv-Team</div>
      </a.div>

      <a.img
        style={{
          transform: weissPosition,
          shapeOutside: `url(${require('./weiss.png')})`
        }}
        src={require('./weiss.png')}
        alt='Piktogramm für «Allgender»-Toiletten.'
        className={'weiss'}
      />
      <a.img
        style={{ transform: schwarzPosition }}
        src={require('./schwarz.png')}
        alt='Kasperli und das «Negermeitli» Susu aus dem Hörspiel «De Schorsch Gaggo reist uf Afrika».'
        className={'schwarz'}
      />

      {/*
      <a.img
        style={{
          transform: genderPosition,
          shapeOutside: `url(${require('./allgender.png')})`
        }}
        src={require('./allgender.png')}
        alt='Piktogramm für «Allgender»-Toiletten.'
        className={'gender'}
      />
      <a.img
        style={{ transform: kasperliPosition }}
        src={require('./kasperli.png')}
        alt='Kasperli und das «Negermeitli» Susu aus dem Hörspiel «De Schorsch Gaggo reist uf Afrika».'
        className={'kasperli'}
      />
      */}
    </div>
  )
}
